import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { isTaskOnTime } from '../../data/mockData';
import './Charts.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const OnTimeVsDelayedChart = ({ tasks }) => {
  let onTime = 0;
  let delayed = 0;
  let inProgress = 0;
  tasks.forEach(task => {
    const s = task.currentStatus || task.status;
    if (s === 'Completed') {
      const onTimeFlag = isTaskOnTime(task);
      if (onTimeFlag === true) onTime++;
      else if (onTimeFlag === false) delayed++;
    } else if (s === 'Delayed') delayed++;
    else if (['To Do', 'In Development', 'In QA', 'Client Review', 'Blocked'].includes(s)) inProgress++;
  });

  const total = onTime + delayed + inProgress;
  if (total === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty-state"><p>No tasks to display</p></div>
      </div>
    );
  }

  const chartData = {
    labels: ['On time', 'Delayed / Late', 'In progress'],
    datasets: [{
      data: [onTime, delayed, inProgress],
      backgroundColor: [
        'rgba(34, 197, 94, 0.85)',
        'rgba(239, 68, 68, 0.85)',
        'rgba(148, 163, 184, 0.85)'
      ],
      borderColor: 'rgba(255,255,255,0.9)',
      borderWidth: 1
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { padding: 12, usePointStyle: true } },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const t = ctx.dataset.data.reduce((a, b) => a + b, 0);
            const pct = t ? ((ctx.parsed / t) * 100).toFixed(1) : 0;
            return `${ctx.label}: ${ctx.parsed} (${pct}%)`;
          }
        }
      }
    }
  };

  return (
    <div className="chart-container">
      <h4 className="chart-title">On-time vs delayed</h4>
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default OnTimeVsDelayedChart;
